(function (root) {
  const rules = [
    {tag:'Boneless', label:'boneless', pattern:/\b(?:boneless|bone[ -]free|no[ -]bone)\b/gi},
    {tag:'PPPuppySearch', label:'puppy', pattern:/\b(?:puppy|puppies)\b/gi},
    {tag:'PPSearchChickenFree', label:'chicken free', pattern:/\b(?:chicken[ -]free|no[ -]chicken)\b/gi},
    {tag:'PPSearchGrainFree', label:'grain free', pattern:/\b(?:grain[ -]free|no[ -]grains?)\b/gi},
    {tag:'PPSearchSingleProtein', label:'single protein', pattern:/\b(?:single[ -]protein|mono[ -]?protein|single[ -]animal[ -]protein)\b/gi},
    {tag:'PPSearchLowFat', label:'low fat', pattern:/\b(?:low[ -]fat|lower[ -]fat)\b/gi}
  ];
  function normalise(value) {
    let query = String(value || '');
    const saved = [];
    query = query.replace(/(?:tag|title|vendor|product_type):[^\s()]+/gi, tag => { saved.push(tag); return `\u0001${saved.length-1}\u0002`; });
    for (const rule of rules) query = query.replace(rule.pattern, `tag:${rule.tag}`);
    query = query.replace(/\u0001(\d+)\u0002/g, (_,i) => saved[Number(i)]);
    if (/tag:/i.test(query) && !/[()]/.test(query) && !/\b(?:OR|NOT)\b/.test(query)) {
      query = query.trim().split(/\s+/).filter(term => term !== 'AND').map(term => /^(?:tag|title|vendor|product_type):/i.test(term) ? term : `(title:${term} OR vendor:${term} OR product_type:${term})`).join(' AND ');
    }
    return query;
  }
  function display(value) {
    let text = String(value || '');
    for (const rule of rules) text = text.replace(new RegExp(`tag:${rule.tag}\\b`,'gi'),rule.label);
    return text.replace(/\(title:([^\s()]+) OR vendor:[^\s()]+ OR product_type:[^\s()]+\)/gi,'$1').replace(/\s*tag:PPSearch(?:Category|Form)[A-Za-z]+\b/gi,'').replace(/\bAND\b/g,'').replace(/\s+/g,' ').trim();
  }
  const api = {normalise, display};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document) return;
  root.PPSmartSearch = api;
  root.ppBonelessSearchQuery = normalise;
  const searchPath = root.ppSearchPath || '/search';
  const current = new URL(root.location.href);
  if (current.pathname === searchPath && current.searchParams.has('q')) {
    const original = current.searchParams.get('q'), query = normalise(original);
    if (query !== original) { current.searchParams.set('q',query); current.searchParams.set('type','product'); root.location.replace(current.href); }
  }
  root.document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    const target = new URL(form.action, root.location.origin);
    if (target.pathname !== searchPath) return;
    const data = new FormData(form), original = String(data.get('q') || ''), query = normalise(original);
    if (query === original) return;
    event.preventDefault();
    for (const [key,value] of data) if (typeof value === 'string') target.searchParams.set(key,value);
    target.searchParams.set('q',query); target.searchParams.set('type','product'); root.location.assign(target.href);
  });
  function tidy() {
    root.document.querySelectorAll('input[type="search"][name="q"]').forEach(input => { input.value = display(input.value); });
    root.document.title = display(root.document.title);
  }
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded',tidy); else tidy();
})(typeof window === 'undefined' ? globalThis : window);
